const hasValue = (value) => {
    return !!value || value === 0 || value === '0' || value === false
}

const convertBytesToBG = (value = 0) => {
    return value / 1073741824
}

export { hasValue, convertBytesToBG }